(() => {
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const lerp = (start, end, progress) => start + (end - start) * progress;
  const range = (value, start, end) => clamp((value - start) / (end - start));

  function initHero(hero) {
    if (!hero || hero.dataset.senshenInitialized === 'true') return;

    const card = hero.querySelector('[data-senshen-card]');
    const pointer = hero.querySelector('[data-senshen-card-pointer]');
    const pointerArea = hero.querySelector('[data-senshen-card-wrap]');
    const front = hero.querySelector('[data-senshen-front]');
    const back = hero.querySelector('[data-senshen-back]');
    const foil = hero.querySelector('[data-senshen-foil]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!card || !pointer || !pointerArea || !front || !back || !foil) return;

    hero.dataset.senshenInitialized = 'true';
    let frame = 0;
    let destroyed = false;

    const render = () => {
      frame = 0;
      if (destroyed || reduceMotion.matches) {
        card.style.transform = '';
        front.style.opacity = '1';
        back.style.opacity = '0';
        foil.style.opacity = '0';
        return;
      }

      const rect = hero.getBoundingClientRect();
      const distance = Math.max(1, hero.offsetHeight - window.innerHeight);
      const progress = clamp(-rect.top / distance);
      let rotation = 0;
      let y = 0;
      let scale = 1;

      if (progress < 0.18) {
        const phase = range(progress, 0, 0.18);
        y = lerp(0, -12, phase);
        scale = lerp(1, 1.015, phase);
      } else if (progress < 0.5) {
        const phase = range(progress, 0.18, 0.5);
        rotation = lerp(0, 90, phase);
        y = lerp(-12, -32, phase);
        scale = lerp(1.015, 1.06, phase);
      } else if (progress < 0.86) {
        const phase = range(progress, 0.5, 0.86);
        rotation = lerp(90, 0, phase);
        y = -32;
        scale = 1.06;
      } else {
        const phase = range(progress, 0.86, 1);
        y = lerp(-32, -8, phase);
        scale = lerp(1.06, 1.015, phase);
      }

      card.style.transform = `translate3d(0, ${y}px, 0) rotateY(${rotation}deg) scale(${scale})`;
      front.style.opacity = progress < 0.5 ? '1' : '0';
      back.style.opacity = progress < 0.5 ? '0' : '1';

      const foilPhase = range(progress, 0.3, 0.82);
      const foilOpacity = Math.sin(foilPhase * Math.PI) * 0.92;
      foil.style.transform = `skewX(-14deg) translateX(${lerp(-120, 430, foilPhase)}%)`;
      foil.style.opacity = String(Math.max(0, foilOpacity));
    };

    const requestRender = () => {
      if (!frame) frame = window.requestAnimationFrame(render);
    };

    const onPointerMove = (event) => {
      if (reduceMotion.matches || window.matchMedia('(pointer: coarse)').matches) return;
      const rect = pointerArea.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      pointer.style.transform = `rotateX(${y * -4}deg) rotateZ(${x * 1.5}deg)`;
    };

    const onPointerLeave = () => {
      pointer.style.transform = 'rotateX(0deg) rotateZ(0deg)';
    };

    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestRender, { passive: true });
    reduceMotion.addEventListener('change', requestRender);
    pointerArea.addEventListener('pointermove', onPointerMove, { passive: true });
    pointerArea.addEventListener('pointerleave', onPointerLeave);
    render();

    hero.senshenDestroy = () => {
      destroyed = true;
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', requestRender);
      window.removeEventListener('resize', requestRender);
      reduceMotion.removeEventListener('change', requestRender);
      pointerArea.removeEventListener('pointermove', onPointerMove);
      pointerArea.removeEventListener('pointerleave', onPointerLeave);
      delete hero.dataset.senshenInitialized;
    };
  }

  function initDrawerClose(button) {
    if (!button || button.dataset.senshenInitialized === 'true') return;

    const details = button.closest('details');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;

    button.dataset.senshenInitialized = 'true';
    button.addEventListener('click', () => summary.click());
  }

  function initAccountComponent(component) {
    if (!component || component.dataset.senshenInitialized === 'true') return;

    component.dataset.senshenInitialized = 'true';
    component.addEventListener('open', () => {
      const details = component.closest('details[open]');
      const summary = details?.querySelector(':scope > summary');
      summary?.click();
    });
  }

  function init(root = document) {
    root.querySelectorAll('[data-senshen-hero]').forEach(initHero);
    root.querySelectorAll('[data-senshen-menu-close]').forEach(initDrawerClose);
    root.querySelectorAll('shopify-account').forEach(initAccountComponent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-senshen-hero]').forEach((hero) => hero.senshenDestroy?.());
  });
})();
